import React from 'react';
import ReportingBookingOffersPage from '../components/ReportingBookingOffersPage';

const ReportingBookingOffersApp = (props) => (
  <ReportingBookingOffersPage {...props} />
);

export default ReportingBookingOffersApp;
